var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-spin",
    { attrs: { size: "large", spinning: _vm.loading } },
    [
      _c("div", { staticClass: "wrap-leads" }, [
        _c("div", { staticClass: "wrap-box" }, [
          _c("div", { staticClass: "nav" }, [
            _c("div", { staticClass: "title", class: [_vm.lang] }, [
              _vm._v(_vm._s(_vm.$t("importMethod"))),
            ]),
            _c(
              "ul",
              _vm._l(_vm.navList, function (item, index) {
                return _c(
                  "li",
                  {
                    key: index,
                    class: {
                      selected: item.selected ? true : false,
                      AR: _vm.lang === "AR" ? true : false,
                      disabledClick: _vm.statusIsEdit,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.tabHandler(item.value)
                      },
                    },
                  },
                  [
                    _c("img", {
                      style: {
                        "margin-left": _vm.lang == "AR" ? "10px" : "0",
                        "margin-right": _vm.lang !== "AR" ? "10px" : "0",
                      },
                      attrs: { src: item.url },
                    }),
                    _c("span", [_vm._v(_vm._s(item.label))]),
                  ]
                )
              }),
              0
            ),
          ]),
          _c("div", { staticClass: "formBox" }, [
            _c(
              "div",
              { staticClass: "step-hint-bar m16" },
              [
                _c("div", { staticClass: "step-hint-left" }, [
                  _c("span", { staticClass: "hand-icon" }, [_vm._v("👋")]),
                  _c("div", { staticClass: "step-hint-text" }, [
                    _c("div", { staticClass: "step-hint-title" }, [
                      _vm._v(" " + _vm._s(_vm.$t("Step2HintTitle")) + " "),
                    ]),
                    _c("div", {
                      staticClass: "step-hint-desc",
                      domProps: { innerHTML: _vm._s(_vm.$t("Step2HintDesc")) },
                    }),
                  ]),
                ]),
                _c(
                  "a-button",
                  {
                    staticClass: "pro-hint-btn",
                    class: { "minimized-btn": !_vm.showTipsInfo },
                    attrs: { shape: "round", size: "small" },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("toggleIntro", !_vm.showTipsInfo)
                      },
                    },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.showTipsInfo
                            ? _vm.$t("ProHintBtnShow")
                            : _vm.$t("ProHintBtnHide")
                        ) +
                        " "
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm.currentIndex == 1
              ? _c("div", { staticClass: "title", class: [_vm.lang] }, [
                  _vm._v(" " + _vm._s(_vm.$t("LinkedInSearchURL")) + " "),
                ])
              : _vm.currentIndex == 2
              ? _c("div", { staticClass: "title", class: [_vm.lang] }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.type == 1
                          ? _vm.$t("SalesNavigator")
                          : _vm.$t("Recruiter")
                      ) +
                      " "
                  ),
                ])
              : _vm.currentIndex == 3
              ? _c("div", { staticClass: "title", class: [_vm.lang] }, [
                  _vm._v(" " + _vm._s(_vm.$t("LinkedInEvents")) + " "),
                ])
              : _vm.currentIndex == 4
              ? _c("div", { staticClass: "title", class: [_vm.lang] }, [
                  _vm._v(" " + _vm._s(_vm.$t("LinkedInPosts")) + " "),
                ])
              : _vm.currentIndex == 5
              ? _c("div", { staticClass: "title", class: [_vm.lang] }, [
                  _vm._v(" " + _vm._s(_vm.$t("ImportfromCSV")) + " "),
                ])
              : _vm.currentIndex == 6
              ? _c("div", { staticClass: "title", class: [_vm.lang] }, [
                  _vm._v(" " + _vm._s(_vm.$t("LinkedInGroup")) + " "),
                ])
              : _vm._e(),
            _c(
              "div",
              {
                staticClass: "mbox",
                style: {
                  height: _vm.maxWindowHeight + "px",
                  width: "100%",
                },
              },
              [
                _c(
                  "a-form",
                  {
                    ref: "formLeads",
                    staticClass: "form",
                    attrs: { form: _vm.formLeads },
                  },
                  [
                    _vm.currentIndex == 1
                      ? [
                          _c(
                            "div",
                            { staticClass: "label-des", class: [_vm.lang] },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.$t("EnterLinkedInsearchURL"))
                                ),
                              ]),
                            ]
                          ),
                          _c(
                            "a-form-item",
                            { class: [_vm.lang] },
                            [
                              _c("a-input", {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator",
                                    value: [
                                      "search_url1",
                                      {
                                        initialValue: _vm.search_url1,
                                        rules: [
                                          {
                                            required: true,
                                            validator: async function (
                                              rule,
                                              value,
                                              callback
                                            ) {
                                              if (!value || !value.trim("")) {
                                                callback(_vm.$t("selectUrl"))
                                                return
                                              }
                                              // 添加逻辑校验是否存在调接口
                                              let res =
                                                await _vm.isHaveSearchUrl(value)
                                              if (!res.reslut) {
                                                callback(res.msg)
                                                return
                                              }
                                              callback()
                                            },
                                          },
                                        ],
                                        trigger: "blur",
                                      },
                                    ],
                                    expression:
                                      "[\n                    'search_url1',\n                    {\n                      initialValue: search_url1,\n                      rules: [\n                        {\n                          required: true,\n                          validator: async function (rule, value, callback) {\n                            if (!value || !value.trim('')) {\n                              callback($t('selectUrl'));\n                              return;\n                            }\n                            // 添加逻辑校验是否存在调接口\n                            let res = await isHaveSearchUrl(value);\n                            if (!res.reslut) {\n                              callback(res.msg);\n                              return;\n                            }\n                            callback();\n                          },\n                        },\n                      ],\n                      trigger: 'blur',\n                    },\n                  ]",
                                  },
                                ],
                                staticClass: "input",
                                attrs: {
                                  size: "large",
                                  disabled: _vm.statusIsEdit,
                                  placeholder: _vm.$t(
                                    "PleaseenterLinkedInBasicURLhere"
                                  ),
                                },
                              }),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.showTipsInfo,
                                      expression: "showTipsInfo",
                                    },
                                  ],
                                  staticClass: "input-tip",
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "input-tip-icon" },
                                    [_vm._v("💡")]
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "input-tip-text" },
                                    [_vm._v(_vm._s(_vm.$t("PasteUrlTip")))]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "popbox popboxAni beauty-scroll" },
                            [
                              _c(
                                "p",
                                {
                                  staticClass: "main-tit",
                                  class: [_vm.lang],
                                  style: {
                                    "text-align":
                                      _vm.lang == "AR" ? "right" : "left",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("HowtofindbasicsearchURL")
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "ptit",
                                  class: [_vm.lang],
                                  style: {
                                    "text-align":
                                      _vm.lang == "AR" ? "right" : "left",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "num",
                                      class: {
                                        rtl: _vm.lang == "AR" ? true : false,
                                      },
                                    },
                                    [_vm._v("1")]
                                  ),
                                  _c("span", { class: [_vm.lang] }, [
                                    _vm._v(_vm._s(_vm.$t("EnterkeyWords"))),
                                  ]),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  style: {
                                    "text-align":
                                      _vm.lang == "AR" ? "right" : "left",
                                  },
                                },
                                [
                                  _c("img", {
                                    staticClass: "search",
                                    staticStyle: { display: "inline" },
                                    attrs: {
                                      src: require("@/assets/img/leads/1-1.png"),
                                      alt: "",
                                    },
                                  }),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "ptit",
                                  class: [_vm.lang],
                                  style: {
                                    "text-align":
                                      _vm.lang == "AR" ? "right" : "left",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "num",
                                      class: {
                                        rtl: _vm.lang == "AR" ? true : false,
                                      },
                                    },
                                    [_vm._v("2")]
                                  ),
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.$t("CopyTheLink"))),
                                  ]),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  style: {
                                    "text-align":
                                      _vm.lang == "AR" ? "right" : "left",
                                  },
                                },
                                [
                                  _c("img", {
                                    staticClass: "search",
                                    attrs: {
                                      src: require("@/assets/img/leads/1-2.png"),
                                      alt: "",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ]
                      : _vm.currentIndex == 2
                      ? [
                          _vm.type == 1
                            ? [
                                _c(
                                  "div",
                                  {
                                    staticClass: "label-des",
                                    class: [_vm.lang],
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.$t("EnterSales"))),
                                    ]),
                                  ]
                                ),
                                _c(
                                  "a-form-item",
                                  { class: [_vm.lang] },
                                  [
                                    _c("a-input", {
                                      directives: [
                                        {
                                          name: "decorator",
                                          rawName: "v-decorator",
                                          value: [
                                            "search_url2",
                                            {
                                              initialValue: _vm.search_url2,
                                              rules: [
                                                {
                                                  required: true,
                                                  validator: async function (
                                                    rule,
                                                    value,
                                                    callback
                                                  ) {
                                                    if (
                                                      !value ||
                                                      !value.trim("")
                                                    ) {
                                                      callback(
                                                        _vm.$t("selectUrl")
                                                      )
                                                      return
                                                    }
                                                    // 添加逻辑校验是否存在调接口
                                                    let res =
                                                      await _vm.isHaveSearchUrl(
                                                        value
                                                      )
                                                    if (!res.reslut) {
                                                      callback(res.msg)
                                                      return
                                                    }
                                                    callback()
                                                  },
                                                },
                                              ],
                                              trigger: "blur",
                                            },
                                          ],
                                          expression:
                                            "[\n                      'search_url2',\n                      {\n                        initialValue: search_url2,\n                        rules: [\n                          {\n                            required: true,\n                            validator: async function (\n                              rule,\n                              value,\n                              callback,\n                            ) {\n                              if (!value || !value.trim('')) {\n                                callback($t('selectUrl'));\n                                return;\n                              }\n                              // 添加逻辑校验是否存在调接口\n                              let res = await isHaveSearchUrl(value);\n                              if (!res.reslut) {\n                                callback(res.msg);\n                                return;\n                              }\n                              callback();\n                            },\n                          },\n                        ],\n                        trigger: 'blur',\n                      },\n                    ]",
                                        },
                                      ],
                                      staticClass: "input",
                                      attrs: {
                                        size: "large",
                                        disabled: _vm.statusIsEdit,
                                        placeholder: _vm.$t(
                                          "PleaseEnterSalesNavigator"
                                        ),
                                      },
                                    }),
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.showTipsInfo,
                                            expression: "showTipsInfo",
                                          },
                                        ],
                                        staticClass: "input-tip",
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "input-tip-icon" },
                                          [_vm._v("💡")]
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "input-tip-text" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("PasteUrlTip"))
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "popbox popboxAni beauty-scroll",
                                  },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticClass: "main-tit",
                                        class: [_vm.lang],
                                        style: {
                                          "text-align":
                                            _vm.lang == "AR" ? "right" : "left",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("Howtofindasales")) +
                                            " "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "ptit",
                                        class: [_vm.lang],
                                        style: {
                                          "text-align":
                                            _vm.lang == "AR" ? "right" : "left",
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "num",
                                            class: {
                                              rtl:
                                                _vm.lang == "AR" ? true : false,
                                            },
                                          },
                                          [_vm._v("1")]
                                        ),
                                        _c("span", { class: [_vm.lang] }, [
                                          _vm._v(
                                            _vm._s(_vm.$t("Openyourbrowser")) +
                                              " "
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "ptit",
                                        class: [_vm.lang],
                                        style: {
                                          "text-align":
                                            _vm.lang == "AR" ? "right" : "left",
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "num",
                                            class: {
                                              rtl:
                                                _vm.lang == "AR" ? true : false,
                                            },
                                          },
                                          [_vm._v("2")]
                                        ),
                                        _c("span", { class: [_vm.lang] }, [
                                          _vm._v(
                                            _vm._s(_vm.$t("Logintoyoursales"))
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "ptit",
                                        class: [_vm.lang],
                                        style: {
                                          "text-align":
                                            _vm.lang == "AR" ? "right" : "left",
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "num",
                                            class: {
                                              rtl:
                                                _vm.lang == "AR" ? true : false,
                                            },
                                          },
                                          [_vm._v("3")]
                                        ),
                                        _c("span", { class: [_vm.lang] }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("Enterkeywordsandpress")
                                            ) + " "
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        style: {
                                          "text-align":
                                            _vm.lang == "AR" ? "right" : "left",
                                        },
                                      },
                                      [
                                        _c("img", {
                                          staticClass: "search",
                                          staticStyle: { display: "inline" },
                                          attrs: {
                                            src: require("@/assets/img/leads/2-1.png"),
                                            alt: "",
                                          },
                                        }),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "ptit",
                                        class: [_vm.lang],
                                        style: {
                                          "text-align":
                                            _vm.lang == "AR" ? "right" : "left",
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "num",
                                            class: {
                                              rtl:
                                                _vm.lang == "AR" ? true : false,
                                            },
                                          },
                                          [_vm._v("4")]
                                        ),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.$t("Usefilterstofind"))
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        style: {
                                          "text-align":
                                            _vm.lang == "AR" ? "right" : "left",
                                        },
                                      },
                                      [
                                        _c("img", {
                                          staticClass: "search",
                                          attrs: {
                                            src: require("@/assets/img/leads/2-2.png"),
                                            alt: "",
                                          },
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            : [
                                _c(
                                  "div",
                                  {
                                    staticClass: "label-des",
                                    class: [_vm.lang],
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.$t("EnterRecruiterURL"))
                                      ),
                                    ]),
                                  ]
                                ),
                                _c(
                                  "a-form-item",
                                  { class: [_vm.lang] },
                                  [
                                    _c("a-input", {
                                      directives: [
                                        {
                                          name: "decorator",
                                          rawName: "v-decorator",
                                          value: [
                                            "search_url2",
                                            {
                                              initialValue: _vm.search_url2,
                                              rules: [
                                                {
                                                  required: true,
                                                  validator: async function (
                                                    rule,
                                                    value,
                                                    callback
                                                  ) {
                                                    if (
                                                      !value ||
                                                      !value.trim("")
                                                    ) {
                                                      callback(
                                                        _vm.$t("selectUrl")
                                                      )
                                                      return
                                                    }
                                                    // 添加逻辑校验是否存在调接口
                                                    let res =
                                                      await _vm.isHaveSearchUrl(
                                                        value
                                                      )
                                                    if (!res.reslut) {
                                                      callback(res.msg)
                                                      return
                                                    }
                                                    callback()
                                                  },
                                                },
                                              ],
                                              trigger: "blur",
                                            },
                                          ],
                                          expression:
                                            "[\n                      'search_url2',\n                      {\n                        initialValue: search_url2,\n                        rules: [\n                          {\n                            required: true,\n                            validator: async function (\n                              rule,\n                              value,\n                              callback,\n                            ) {\n                              if (!value || !value.trim('')) {\n                                callback($t('selectUrl'));\n                                return;\n                              }\n                              // 添加逻辑校验是否存在调接口\n                              let res = await isHaveSearchUrl(value);\n                              if (!res.reslut) {\n                                callback(res.msg);\n                                return;\n                              }\n                              callback();\n                            },\n                          },\n                        ],\n                        trigger: 'blur',\n                      },\n                    ]",
                                        },
                                      ],
                                      staticClass: "input",
                                      attrs: {
                                        size: "large",
                                        disabled: _vm.statusIsEdit,
                                        placeholder: _vm.$t(
                                          "RecruitersearchURLhere"
                                        ),
                                      },
                                    }),
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.showTipsInfo,
                                            expression: "showTipsInfo",
                                          },
                                        ],
                                        staticClass: "input-tip",
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "input-tip-icon" },
                                          [_vm._v("💡")]
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "input-tip-text" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("PasteUrlTip"))
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "recruiterValidUrl" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("recruiterValidUrl")) +
                                        " "
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "popbox popboxAni beauty-scroll",
                                  },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticClass: "main-tit",
                                        class: [_vm.lang],
                                        style: {
                                          "text-align":
                                            _vm.lang == "AR" ? "right" : "left",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("RecruiterURL")) +
                                            " "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "ptit",
                                        class: [_vm.lang],
                                        style: {
                                          "text-align":
                                            _vm.lang == "AR" ? "right" : "left",
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "num",
                                            class: {
                                              rtl:
                                                _vm.lang == "AR" ? true : false,
                                            },
                                          },
                                          [_vm._v("1")]
                                        ),
                                        _c("span", { class: [_vm.lang] }, [
                                          _vm._v(
                                            _vm._s(_vm.$t("RecruiterOpen")) +
                                              " "
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "ptit",
                                        class: [_vm.lang],
                                        style: {
                                          "text-align":
                                            _vm.lang == "AR" ? "right" : "left",
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "num",
                                            class: {
                                              rtl:
                                                _vm.lang == "AR" ? true : false,
                                            },
                                          },
                                          [_vm._v("2")]
                                        ),
                                        _c("span", { class: [_vm.lang] }, [
                                          _vm._v(
                                            _vm._s(_vm.$t("RecruiterKeyWords"))
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        style: {
                                          "text-align":
                                            _vm.lang == "AR" ? "right" : "left",
                                        },
                                      },
                                      [
                                        _c("img", {
                                          staticClass: "search",
                                          staticStyle: { display: "inline" },
                                          attrs: {
                                            src: require("@/assets/img/leads/7-1.png"),
                                            alt: "",
                                          },
                                        }),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "ptit",
                                        class: [_vm.lang],
                                        style: {
                                          "text-align":
                                            _vm.lang == "AR" ? "right" : "left",
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "num",
                                            class: {
                                              rtl:
                                                _vm.lang == "AR" ? true : false,
                                            },
                                          },
                                          [_vm._v("3")]
                                        ),
                                        _c("span", { class: [_vm.lang] }, [
                                          _vm._v(
                                            _vm._s(_vm.$t("Usefilters")) + " "
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        style: {
                                          "text-align":
                                            _vm.lang == "AR" ? "right" : "left",
                                        },
                                      },
                                      [
                                        _c("img", {
                                          staticStyle: {
                                            display: "inline",
                                            width: "180px",
                                          },
                                          attrs: {
                                            src: require("@/assets/img/leads/7-2.png"),
                                            alt: "",
                                          },
                                        }),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        style: {
                                          "text-align":
                                            _vm.lang == "AR" ? "right" : "left",
                                        },
                                      },
                                      [
                                        _c("img", {
                                          staticClass: "search",
                                          staticStyle: { display: "inline" },
                                          attrs: {
                                            src: require("@/assets/img/leads/7-3.png"),
                                            alt: "",
                                          },
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                        ]
                      : _vm.currentIndex == 3
                      ? [
                          _c(
                            "div",
                            { staticClass: "label-des", class: [_vm.lang] },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("EnterLinkedInEventURL"))),
                              ]),
                            ]
                          ),
                          _c(
                            "a-form-item",
                            { class: [_vm.lang] },
                            [
                              _c("a-input", {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator",
                                    value: [
                                      "search_url3",
                                      {
                                        initialValue: _vm.search_url3,
                                        rules: [
                                          {
                                            required: true,
                                            validator: async function (
                                              rule,
                                              value,
                                              callback
                                            ) {
                                              if (!value || !value.trim("")) {
                                                callback(_vm.$t("selectUrl"))
                                                return
                                              }
                                              // 添加逻辑校验是否存在调接口
                                              let res =
                                                await _vm.isHaveSearchUrl(value)
                                              if (!res.reslut) {
                                                callback(res.msg)
                                                return
                                              }
                                              callback()
                                            },
                                          },
                                        ],
                                        trigger: "blur",
                                      },
                                    ],
                                    expression:
                                      "[\n                    'search_url3',\n                    {\n                      initialValue: search_url3,\n                      rules: [\n                        {\n                          required: true,\n                          validator: async function (rule, value, callback) {\n                            if (!value || !value.trim('')) {\n                              callback($t('selectUrl'));\n                              return;\n                            }\n                            // 添加逻辑校验是否存在调接口\n                            let res = await isHaveSearchUrl(value);\n                            if (!res.reslut) {\n                              callback(res.msg);\n                              return;\n                            }\n                            callback();\n                          },\n                        },\n                      ],\n                      trigger: 'blur',\n                    },\n                  ]",
                                  },
                                ],
                                staticClass: "input",
                                attrs: {
                                  size: "large",
                                  disabled: _vm.statusIsEdit,
                                  placeholder: _vm.$t(
                                    "PleaseenteraLinkedInEventURLhere"
                                  ),
                                },
                              }),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.showTipsInfo,
                                      expression: "showTipsInfo",
                                    },
                                  ],
                                  staticClass: "input-tip",
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "input-tip-icon" },
                                    [_vm._v("💡")]
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "input-tip-text" },
                                    [_vm._v(_vm._s(_vm.$t("PasteUrlTip")))]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm.keyList.length > 0
                            ? _c("div", { staticClass: "keywords" }, [
                                _c("div", { staticClass: "avat" }),
                                _c(
                                  "div",
                                  { staticClass: "tit", class: [_vm.lang] },
                                  [
                                    _vm._v(
                                      " " + _vm._s(_vm.$t("keyworkds")) + " "
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "keyList" },
                                  _vm._l(_vm.keyList, function (item, index) {
                                    return _c("span", { key: index }, [
                                      _vm._v(_vm._s(item)),
                                    ])
                                  }),
                                  0
                                ),
                              ])
                            : _vm._e(),
                          _c(
                            "div",
                            { staticClass: "popbox popboxAni beauty-scroll" },
                            [
                              _c(
                                "p",
                                {
                                  staticClass: "main-tit",
                                  class: [_vm.lang],
                                  style: {
                                    "text-align":
                                      _vm.lang == "AR" ? "right" : "left",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("HowtofindaLinkedIneventURL")
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "ptit",
                                  class: [_vm.lang],
                                  style: {
                                    "text-align":
                                      _vm.lang == "AR" ? "right" : "left",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "num",
                                      class: {
                                        rtl: _vm.lang == "AR" ? true : false,
                                      },
                                    },
                                    [_vm._v("1")]
                                  ),
                                  _c("span", { class: [_vm.lang] }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("OpenLinkedIn")) + " "
                                    ),
                                  ]),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  style: {
                                    "text-align":
                                      _vm.lang == "AR" ? "right" : "left",
                                  },
                                },
                                [
                                  _c("img", {
                                    staticClass: "search",
                                    staticStyle: { display: "inline" },
                                    attrs: {
                                      src: require("@/assets/img/leads/3-1.png"),
                                      alt: "",
                                    },
                                  }),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "ptit",
                                  class: [_vm.lang],
                                  style: {
                                    "text-align":
                                      _vm.lang == "AR" ? "right" : "left",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "num",
                                      class: {
                                        rtl: _vm.lang == "AR" ? true : false,
                                      },
                                    },
                                    [_vm._v("2")]
                                  ),
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.$t("ClickAttend"))),
                                  ]),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  style: {
                                    "text-align":
                                      _vm.lang == "AR" ? "right" : "left",
                                  },
                                },
                                [
                                  _c("img", {
                                    staticClass: "search",
                                    attrs: {
                                      src: require("@/assets/img/leads/3-2.png"),
                                      alt: "",
                                    },
                                  }),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "ptit",
                                  class: [_vm.lang],
                                  style: {
                                    "text-align":
                                      _vm.lang == "AR" ? "right" : "left",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "num",
                                      class: {
                                        rtl: _vm.lang == "AR" ? true : false,
                                      },
                                    },
                                    [_vm._v("3")]
                                  ),
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.$t("GotoAttendees"))),
                                  ]),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  style: {
                                    "text-align":
                                      _vm.lang == "AR" ? "right" : "left",
                                  },
                                },
                                [
                                  _c("img", {
                                    staticClass: "search",
                                    attrs: {
                                      src: require("@/assets/img/leads/3-3.png"),
                                      alt: "",
                                    },
                                  }),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "ptit",
                                  class: [_vm.lang],
                                  style: {
                                    "text-align":
                                      _vm.lang == "AR" ? "right" : "left",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "num",
                                      class: {
                                        rtl: _vm.lang == "AR" ? true : false,
                                      },
                                    },
                                    [_vm._v("4")]
                                  ),
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.$t("Copypaste"))),
                                  ]),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  style: {
                                    "text-align":
                                      _vm.lang == "AR" ? "right" : "left",
                                  },
                                },
                                [
                                  _c("img", {
                                    staticClass: "search",
                                    attrs: {
                                      src: require("@/assets/img/leads/3-4.png"),
                                      alt: "",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ]
                      : _vm.currentIndex == 4
                      ? [
                          _c(
                            "div",
                            { staticClass: "label-des", class: [_vm.lang] },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("EnterLinkedInPostURL"))),
                              ]),
                            ]
                          ),
                          _c(
                            "a-form-item",
                            { class: [_vm.lang] },
                            [
                              _c("a-input", {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator",
                                    value: [
                                      "search_url4",
                                      {
                                        initialValue: _vm.search_url4,
                                        rules: [
                                          {
                                            required: true,
                                            validator: async function (
                                              rule,
                                              value,
                                              callback
                                            ) {
                                              if (!value || !value.trim("")) {
                                                callback(_vm.$t("selectUrl"))
                                                return
                                              }
                                              // 添加逻辑校验是否存在调接口
                                              let res =
                                                await _vm.isHaveSearchUrl(value)
                                              if (!res.reslut) {
                                                callback(res.msg)
                                                return
                                              }
                                              callback()
                                            },
                                          },
                                        ],
                                        trigger: "blur",
                                      },
                                    ],
                                    expression:
                                      "[\n                    'search_url4',\n                    {\n                      initialValue: search_url4,\n                      rules: [\n                        {\n                          required: true,\n                          validator: async function (rule, value, callback) {\n                            if (!value || !value.trim('')) {\n                              callback($t('selectUrl'));\n                              return;\n                            }\n                            // 添加逻辑校验是否存在调接口\n                            let res = await isHaveSearchUrl(value);\n                            if (!res.reslut) {\n                              callback(res.msg);\n                              return;\n                            }\n                            callback();\n                          },\n                        },\n                      ],\n                      trigger: 'blur',\n                    },\n                  ]",
                                  },
                                ],
                                staticClass: "input",
                                attrs: {
                                  size: "large",
                                  disabled: _vm.statusIsEdit,
                                  placeholder: _vm.$t(
                                    "PleaseenterLinkedInPostURLhere"
                                  ),
                                },
                              }),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.showTipsInfo,
                                      expression: "showTipsInfo",
                                    },
                                  ],
                                  staticClass: "input-tip",
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "input-tip-icon" },
                                    [_vm._v("💡")]
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "input-tip-text" },
                                    [_vm._v(_vm._s(_vm.$t("PasteUrlTip")))]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c("div", { staticClass: "wrap-box-switch" }, [
                            _c("ul", [
                              _c(
                                "li",
                                { class: [_vm.lang] },
                                [
                                  _c("a-form-item", { staticClass: "item" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "u-box",
                                        class: [_vm.lang],
                                      },
                                      [
                                        _c(
                                          "p",
                                          {
                                            style: {
                                              "text-align":
                                                _vm.lang == "AR"
                                                  ? "right"
                                                  : "left",
                                            },
                                          },
                                          [
                                            _c("a-icon", {
                                              staticClass: "icon",
                                              style: {
                                                "margin-left":
                                                  _vm.lang == "AR"
                                                    ? "12px"
                                                    : "0",
                                                "margin-right":
                                                  _vm.lang !== "AR"
                                                    ? "12px"
                                                    : "0",
                                              },
                                              attrs: { type: "like" },
                                            }),
                                            _c("span", [
                                              _vm._v(_vm._s(_vm.$t("Likes"))),
                                            ]),
                                          ],
                                          1
                                        ),
                                        _c("a-switch", {
                                          directives: [
                                            {
                                              name: "decorator",
                                              rawName: "v-decorator",
                                              value: [
                                                "post_likes",
                                                {
                                                  initialValue: _vm.detailObj
                                                    .post_likes
                                                    ? true
                                                    : false,
                                                  valuePropName: "checked",
                                                },
                                              ],
                                              expression:
                                                "[\n                            'post_likes',\n                            {\n                              initialValue: detailObj.post_likes\n                                ? true\n                                : false,\n                              valuePropName: 'checked',\n                            },\n                          ]",
                                            },
                                          ],
                                          staticClass: "switch",
                                          attrs: { disabled: _vm.statusIsEdit },
                                          on: { change: _vm.showTipsVal },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]),
                                ],
                                1
                              ),
                              _c(
                                "li",
                                { class: [_vm.lang] },
                                [
                                  _c("a-form-item", { staticClass: "item" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "u-box",
                                        class: [_vm.lang],
                                      },
                                      [
                                        _c(
                                          "p",
                                          {
                                            style: {
                                              "text-align":
                                                _vm.lang == "AR"
                                                  ? "right"
                                                  : "left",
                                            },
                                          },
                                          [
                                            _c("a-icon", {
                                              staticClass: "icon",
                                              style: {
                                                "margin-left":
                                                  _vm.lang == "AR"
                                                    ? "12px"
                                                    : "0",
                                                "margin-right":
                                                  _vm.lang !== "AR"
                                                    ? "12px"
                                                    : "0",
                                              },
                                              attrs: { type: "message" },
                                            }),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(_vm.$t("Comments"))
                                              ),
                                            ]),
                                          ],
                                          1
                                        ),
                                        _c("a-switch", {
                                          directives: [
                                            {
                                              name: "decorator",
                                              rawName: "v-decorator",
                                              value: [
                                                "post_comments",
                                                {
                                                  initialValue: _vm.detailObj
                                                    .post_comments
                                                    ? true
                                                    : false,
                                                  valuePropName: "checked",
                                                },
                                              ],
                                              expression:
                                                "[\n                            'post_comments',\n                            {\n                              initialValue: detailObj.post_comments\n                                ? true\n                                : false,\n                              valuePropName: 'checked',\n                            },\n                          ]",
                                            },
                                          ],
                                          staticClass: "switch",
                                          attrs: { disabled: _vm.statusIsEdit },
                                          on: { change: _vm.showTipsVal },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]),
                                ],
                                1
                              ),
                              _c(
                                "li",
                                {
                                  class: [_vm.lang],
                                  staticStyle: { "margin-bottom": "0" },
                                },
                                [
                                  _c("a-form-item", { staticClass: "item" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "u-box",
                                        class: [_vm.lang],
                                      },
                                      [
                                        _c(
                                          "p",
                                          {
                                            style: {
                                              "text-align":
                                                _vm.lang == "AR"
                                                  ? "right"
                                                  : "left",
                                            },
                                          },
                                          [
                                            _c("a-icon", {
                                              staticClass: "icon",
                                              style: {
                                                "margin-left":
                                                  _vm.lang == "AR"
                                                    ? "12px"
                                                    : "0",
                                                "margin-right":
                                                  _vm.lang !== "AR"
                                                    ? "12px"
                                                    : "0",
                                              },
                                              attrs: { type: "retweet" },
                                            }),
                                            _c("span", [
                                              _vm._v(_vm._s(_vm.$t("Reposts"))),
                                            ]),
                                          ],
                                          1
                                        ),
                                        _c("a-switch", {
                                          directives: [
                                            {
                                              name: "decorator",
                                              rawName: "v-decorator",
                                              value: [
                                                "post_reposts",
                                                {
                                                  initialValue: _vm.detailObj
                                                    .post_reposts
                                                    ? true
                                                    : false,
                                                  valuePropName: "checked",
                                                },
                                              ],
                                              expression:
                                                "[\n                            'post_reposts',\n                            {\n                              initialValue: detailObj.post_reposts\n                                ? true\n                                : false,\n                              valuePropName: 'checked',\n                            },\n                          ]",
                                            },
                                          ],
                                          staticClass: "switch",
                                          attrs: { disabled: _vm.statusIsEdit },
                                          on: { change: _vm.showTipsVal },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ]),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showTips,
                                    expression: "showTips",
                                  },
                                ],
                                class: [_vm.lang],
                                staticStyle: {
                                  color: "red",
                                  "margin-top": "5px",
                                },
                              },
                              [_vm._v(" " + _vm._s(_vm.$t("Note")) + " ")]
                            ),
                          ]),
                          _c("div", { staticClass: "popbox beauty-scroll" }, [
                            _c(
                              "p",
                              {
                                staticClass: "main-tit",
                                class: [_vm.lang],
                                style: {
                                  "text-align":
                                    _vm.lang == "AR" ? "right" : "left",
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("Howimportthepostleads")) +
                                    " "
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "ptit",
                                class: [_vm.lang],
                                style: {
                                  "text-align":
                                    _vm.lang == "AR" ? "right" : "left",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "num",
                                    class: {
                                      rtl: _vm.lang == "AR" ? true : false,
                                    },
                                  },
                                  [_vm._v("1")]
                                ),
                                _c("span", { class: [_vm.lang] }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("Findpostfromrecommendations")
                                    ) + " "
                                  ),
                                ]),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                style: {
                                  "text-align":
                                    _vm.lang == "AR" ? "right" : "left",
                                },
                              },
                              [
                                _c("img", {
                                  staticClass: "search",
                                  staticStyle: {
                                    width: "260px",
                                    height: "auto",
                                    display: "inline",
                                  },
                                  attrs: {
                                    src: require("@/assets/img/leads/4-1.png"),
                                    alt: "",
                                  },
                                }),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "ptit",
                                class: [_vm.lang],
                                style: {
                                  "text-align":
                                    _vm.lang == "AR" ? "right" : "left",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "num",
                                    class: {
                                      rtl: _vm.lang == "AR" ? true : false,
                                    },
                                  },
                                  [_vm._v("2")]
                                ),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("Pastethelinkhere"))),
                                ]),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                style: {
                                  "text-align":
                                    _vm.lang == "AR" ? "right" : "left",
                                },
                              },
                              [
                                _c("img", {
                                  staticClass: "search",
                                  attrs: {
                                    src: require("@/assets/img/leads/4-2.png"),
                                    alt: "",
                                  },
                                }),
                              ]
                            ),
                          ]),
                        ]
                      : _vm.currentIndex == 5
                      ? [
                          !_vm.mappingInfo.fileName
                            ? _c(
                                "div",
                                { staticClass: "label-des", class: [_vm.lang] },
                                [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: "https://u-img.strategybrain.ca/images/files/Import_Template.csv",
                                        target: "_blank",
                                      },
                                    },
                                    [
                                      _c("a-icon", {
                                        staticStyle: {
                                          "margin-right": "5px",
                                          "font-size": "16px",
                                        },
                                        style: {
                                          "margin-left":
                                            _vm.lang == "AR" ? "5px" : "0",
                                          "margin-right":
                                            _vm.lang !== "AR" ? "5px" : "0",
                                        },
                                        attrs: { type: "cloud-download" },
                                      }),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.$t("DownloadexampleCSV"))
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ]
                              )
                            : _vm._e(),
                          !_vm.mappingInfo.fileName
                            ? _c(
                                "div",
                                { staticClass: "wrap-upload" },
                                [
                                  _c(
                                    "a-spin",
                                    {
                                      attrs: {
                                        size: "large",
                                        spinning: _vm.uploading,
                                        tip: _vm.$t("uploading"),
                                      },
                                    },
                                    [
                                      _c(
                                        "a-upload-dragger",
                                        {
                                          attrs: {
                                            name: "file",
                                            multiple: false,
                                            showUploadList: false,
                                            "before-upload": _vm.beforeUpload,
                                          },
                                          on: { change: _vm.handleChange },
                                        },
                                        [
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "ant-upload-drag-icon",
                                            },
                                            [
                                              _c("a-icon", {
                                                attrs: { type: "cloud-upload" },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "p",
                                            { staticClass: "ant-upload-text" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t("DropCSVupload")
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.mappingInfo.fileName
                            ? _c(
                                "div",
                                {
                                  staticClass: "wrap-upload",
                                  staticStyle: { "margin-top": "12px" },
                                },
                                [
                                  _c(
                                    "a-spin",
                                    {
                                      attrs: {
                                        size: "large",
                                        spinning: _vm.uploading,
                                        tip: _vm.$t("uploading"),
                                      },
                                    },
                                    [
                                      _c(
                                        "a-upload",
                                        {
                                          staticStyle: {
                                            display: "block",
                                            width: "100",
                                          },
                                          attrs: {
                                            name: "file",
                                            multiple: false,
                                            showUploadList: false,
                                            "before-upload": _vm.beforeUpload,
                                          },
                                          on: { change: _vm.handleChange },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "uploadInfo" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t("UploadSheet")
                                                  ) +
                                                  " " +
                                                  _vm._s(
                                                    _vm.getFileName(
                                                      _vm.mappingInfo.fileName
                                                    )
                                                  ) +
                                                  " | " +
                                                  _vm._s(
                                                    _vm.mappingInfo.total
                                                  ) +
                                                  " " +
                                                  _vm._s(_vm.$t("LeadsUnit")) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.mappingInfo.fileName
                            ? [
                                _c(
                                  "div",
                                  {
                                    staticClass: "label-des",
                                    class: [_vm.lang],
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.$t("MapLinkedInUR"))),
                                    ]),
                                  ]
                                ),
                                _c(
                                  "a-form-item",
                                  {
                                    class: [_vm.lang],
                                    staticStyle: { "margin-bottom": "14px" },
                                  },
                                  [
                                    _c(
                                      "a-select",
                                      {
                                        directives: [
                                          {
                                            name: "decorator",
                                            rawName: "v-decorator",
                                            value: [
                                              "linkedin_url",
                                              {
                                                initialValue:
                                                  _vm.detailObj.field_mapping
                                                    .linkedin_url ||
                                                  _vm.mappingInfo.linkUrl
                                                    .default,
                                                trigger: ["change"],
                                                rules: [
                                                  {
                                                    required: true,
                                                    message: _vm.$t("required"),
                                                  },
                                                ],
                                              },
                                            ],
                                            expression:
                                              "[\n                      'linkedin_url',\n                      {\n                        initialValue:\n                          detailObj.field_mapping.linkedin_url ||\n                          mappingInfo.linkUrl.default,\n                        trigger: ['change'],\n                        rules: [\n                          {\n                            required: true,\n                            message: $t('required'),\n                          },\n                        ],\n                      },\n                    ]",
                                          },
                                        ],
                                        staticClass: "select",
                                        attrs: {
                                          placeholder: _vm.$t(
                                            "LinkedInUrlPlaceholder"
                                          ),
                                          size: "large",
                                        },
                                      },
                                      _vm._l(
                                        _vm.mappingInfo.linkUrl.list,
                                        function (item, key) {
                                          return _c(
                                            "a-select-option",
                                            {
                                              key: key,
                                              class: [_vm.lang],
                                              attrs: { value: item },
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "optionCont" },
                                                [
                                                  _vm._v(
                                                    " " + _vm._s(item) + " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "label-des",
                                    class: [_vm.lang],
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.$t("MapFirstName"))),
                                    ]),
                                  ]
                                ),
                                _c(
                                  "a-form-item",
                                  {
                                    class: [_vm.lang],
                                    staticStyle: { "margin-bottom": "14px" },
                                  },
                                  [
                                    _c(
                                      "a-select",
                                      {
                                        directives: [
                                          {
                                            name: "decorator",
                                            rawName: "v-decorator",
                                            value: [
                                              "first_name",
                                              {
                                                initialValue:
                                                  _vm.detailObj.field_mapping
                                                    .first_name ||
                                                  _vm.mappingInfo.firstName
                                                    .default,
                                                trigger: "change",
                                                rules: [
                                                  {
                                                    required: true,
                                                    message: _vm.$t("required"),
                                                  },
                                                ],
                                              },
                                            ],
                                            expression:
                                              "[\n                      'first_name',\n                      {\n                        initialValue:\n                          detailObj.field_mapping.first_name ||\n                          mappingInfo.firstName.default,\n                        trigger: 'change',\n                        rules: [\n                          {\n                            required: true,\n                            message: $t('required'),\n                          },\n                        ],\n                      },\n                    ]",
                                          },
                                        ],
                                        staticClass: "select",
                                        attrs: {
                                          placeholder: _vm.$t("FirstName"),
                                          size: "large",
                                        },
                                      },
                                      _vm._l(
                                        _vm.mappingInfo.firstName.list,
                                        function (item, key) {
                                          return _c(
                                            "a-select-option",
                                            {
                                              key: key,
                                              class: [_vm.lang],
                                              attrs: { value: item },
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "optionCont" },
                                                [
                                                  _vm._v(
                                                    " " + _vm._s(item) + " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "label-des",
                                    class: [_vm.lang],
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.$t("MapLastName"))),
                                    ]),
                                  ]
                                ),
                                _c(
                                  "a-form-item",
                                  {
                                    class: [_vm.lang],
                                    staticStyle: { "margin-bottom": "14px" },
                                  },
                                  [
                                    _c(
                                      "a-select",
                                      {
                                        directives: [
                                          {
                                            name: "decorator",
                                            rawName: "v-decorator",
                                            value: [
                                              " last_name",
                                              {
                                                initialValue:
                                                  _vm.detailObj.field_mapping
                                                    .last_name ||
                                                  _vm.mappingInfo.lastName
                                                    .default,
                                                trigger: "change",
                                                rules: [
                                                  {
                                                    required: true,
                                                    message: _vm.$t("required"),
                                                  },
                                                ],
                                              },
                                            ],
                                            expression:
                                              "[\n                      ' last_name',\n                      {\n                        initialValue:\n                          detailObj.field_mapping.last_name ||\n                          mappingInfo.lastName.default,\n                        trigger: 'change',\n                        rules: [\n                          {\n                            required: true,\n                            message: $t('required'),\n                          },\n                        ],\n                      },\n                    ]",
                                          },
                                        ],
                                        staticClass: "select",
                                        attrs: {
                                          placeholder: _vm.$t("LastName"),
                                          size: "large",
                                        },
                                      },
                                      _vm._l(
                                        _vm.mappingInfo.lastName.list,
                                        function (item, key) {
                                          return _c(
                                            "a-select-option",
                                            {
                                              key: key,
                                              class: [_vm.lang],
                                              attrs: { value: item },
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "optionCont" },
                                                [
                                                  _vm._v(
                                                    " " + _vm._s(item) + " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "label-des",
                                    class: [_vm.lang],
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.$t("MapCompany"))),
                                    ]),
                                  ]
                                ),
                                _c(
                                  "a-form-item",
                                  {
                                    class: [_vm.lang],
                                    staticStyle: { "margin-bottom": "14px" },
                                  },
                                  [
                                    _c(
                                      "a-select",
                                      {
                                        directives: [
                                          {
                                            name: "decorator",
                                            rawName: "v-decorator",
                                            value: [
                                              "company_name",
                                              {
                                                initialValue:
                                                  _vm.detailObj.field_mapping
                                                    .company_name ||
                                                  _vm.mappingInfo.companyName
                                                    .default,
                                              },
                                            ],
                                            expression:
                                              "[\n                      'company_name',\n                      {\n                        initialValue:\n                          detailObj.field_mapping.company_name ||\n                          mappingInfo.companyName.default,\n                      },\n                    ]",
                                          },
                                        ],
                                        staticClass: "select",
                                        attrs: {
                                          placeholder: _vm.$t("None"),
                                          size: "large",
                                        },
                                      },
                                      [
                                        _c(
                                          "a-select-option",
                                          {
                                            class: [_vm.lang],
                                            attrs: { value: "" },
                                          },
                                          [
                                            _vm._v(
                                              " " + _vm._s(_vm.$t("None")) + " "
                                            ),
                                          ]
                                        ),
                                        _vm._l(
                                          _vm.mappingInfo.companyName.list,
                                          function (item, key) {
                                            return _c(
                                              "a-select-option",
                                              {
                                                key: key,
                                                class: [_vm.lang],
                                                attrs: { value: item },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "optionCont" },
                                                  [
                                                    _vm._v(
                                                      " " + _vm._s(item) + " "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "label-des",
                                    class: [_vm.lang],
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.$t("MapLocation"))),
                                    ]),
                                  ]
                                ),
                                _c(
                                  "a-form-item",
                                  {
                                    class: [_vm.lang],
                                    staticStyle: { "margin-bottom": "14px" },
                                  },
                                  [
                                    _c(
                                      "a-select",
                                      {
                                        directives: [
                                          {
                                            name: "decorator",
                                            rawName: "v-decorator",
                                            value: [
                                              "location",
                                              {
                                                initialValue:
                                                  _vm.detailObj.field_mapping
                                                    .location ||
                                                  _vm.mappingInfo.location
                                                    .default,
                                              },
                                            ],
                                            expression:
                                              "[\n                      'location',\n                      {\n                        initialValue:\n                          detailObj.field_mapping.location ||\n                          mappingInfo.location.default,\n                      },\n                    ]",
                                          },
                                        ],
                                        staticClass: "select",
                                        attrs: {
                                          placeholder: _vm.$t("None"),
                                          size: "large",
                                        },
                                      },
                                      [
                                        _c(
                                          "a-select-option",
                                          {
                                            class: [_vm.lang],
                                            attrs: { value: "" },
                                          },
                                          [
                                            _vm._v(
                                              " " + _vm._s(_vm.$t("None")) + " "
                                            ),
                                          ]
                                        ),
                                        _vm._l(
                                          _vm.mappingInfo.location.list,
                                          function (item, key) {
                                            return _c(
                                              "a-select-option",
                                              {
                                                key: key,
                                                class: [_vm.lang],
                                                attrs: { value: item },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "optionCont" },
                                                  [
                                                    _vm._v(
                                                      " " + _vm._s(item) + " "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "label-des",
                                    class: [_vm.lang],
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.$t("Maptitle"))),
                                    ]),
                                  ]
                                ),
                                _c(
                                  "a-form-item",
                                  {
                                    class: [_vm.lang],
                                    staticStyle: { "margin-bottom": "14px" },
                                  },
                                  [
                                    _c(
                                      "a-select",
                                      {
                                        directives: [
                                          {
                                            name: "decorator",
                                            rawName: "v-decorator",
                                            value: [
                                              "job_title",
                                              {
                                                initialValue:
                                                  _vm.detailObj.field_mapping
                                                    .job_title ||
                                                  _vm.mappingInfo.title.default,
                                              },
                                            ],
                                            expression:
                                              "[\n                      'job_title',\n                      {\n                        initialValue:\n                          detailObj.field_mapping.job_title ||\n                          mappingInfo.title.default,\n                      },\n                    ]",
                                          },
                                        ],
                                        staticClass: "select",
                                        attrs: {
                                          placeholder: _vm.$t("None"),
                                          size: "large",
                                        },
                                      },
                                      [
                                        _c(
                                          "a-select-option",
                                          {
                                            class: [_vm.lang],
                                            attrs: { value: "" },
                                          },
                                          [
                                            _vm._v(
                                              " " + _vm._s(_vm.$t("None")) + " "
                                            ),
                                          ]
                                        ),
                                        _vm._l(
                                          _vm.mappingInfo.title.list,
                                          function (item, key) {
                                            return _c(
                                              "a-select-option",
                                              {
                                                key: key,
                                                class: [_vm.lang],
                                                attrs: { value: item },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "optionCont" },
                                                  [
                                                    _vm._v(
                                                      " " + _vm._s(item) + " "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "label-des",
                                    class: [_vm.lang],
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.$t("MapEmail"))),
                                    ]),
                                  ]
                                ),
                                _c(
                                  "a-form-item",
                                  {
                                    class: [_vm.lang],
                                    staticStyle: { "margin-bottom": "14px" },
                                  },
                                  [
                                    _c(
                                      "a-select",
                                      {
                                        directives: [
                                          {
                                            name: "decorator",
                                            rawName: "v-decorator",
                                            value: [
                                              "email",
                                              {
                                                initialValue:
                                                  _vm.detailObj.field_mapping
                                                    .email ||
                                                  _vm.mappingInfo.email.default,
                                              },
                                            ],
                                            expression:
                                              "[\n                      'email',\n                      {\n                        initialValue:\n                          detailObj.field_mapping.email ||\n                          mappingInfo.email.default,\n                      },\n                    ]",
                                          },
                                        ],
                                        staticClass: "select",
                                        attrs: {
                                          placeholder: _vm.$t("None"),
                                          size: "large",
                                        },
                                      },
                                      [
                                        _c(
                                          "a-select-option",
                                          {
                                            class: [_vm.lang],
                                            attrs: { value: "" },
                                          },
                                          [
                                            _vm._v(
                                              " " + _vm._s(_vm.$t("None")) + " "
                                            ),
                                          ]
                                        ),
                                        _vm._l(
                                          _vm.mappingInfo.email.list,
                                          function (item, key) {
                                            return _c(
                                              "a-select-option",
                                              {
                                                key: key,
                                                class: [_vm.lang],
                                                attrs: { value: item },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "optionCont" },
                                                  [
                                                    _vm._v(
                                                      " " + _vm._s(item) + " "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "label-des",
                                    class: [_vm.lang],
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.$t("MapPhone"))),
                                    ]),
                                  ]
                                ),
                                _c(
                                  "a-form-item",
                                  {
                                    class: [_vm.lang],
                                    staticStyle: { "margin-bottom": "14px" },
                                  },
                                  [
                                    _c(
                                      "a-select",
                                      {
                                        directives: [
                                          {
                                            name: "decorator",
                                            rawName: "v-decorator",
                                            value: [
                                              "phone_number",
                                              {
                                                initialValue:
                                                  _vm.detailObj.field_mapping
                                                    .phone_number ||
                                                  _vm.mappingInfo.phoneNumber
                                                    .default,
                                              },
                                            ],
                                            expression:
                                              "[\n                      'phone_number',\n                      {\n                        initialValue:\n                          detailObj.field_mapping.phone_number ||\n                          mappingInfo.phoneNumber.default,\n                      },\n                    ]",
                                          },
                                        ],
                                        staticClass: "select",
                                        attrs: {
                                          placeholder: _vm.$t("None"),
                                          size: "large",
                                        },
                                      },
                                      [
                                        _c(
                                          "a-select-option",
                                          {
                                            class: [_vm.lang],
                                            attrs: { value: "" },
                                          },
                                          [
                                            _vm._v(
                                              " " + _vm._s(_vm.$t("None")) + " "
                                            ),
                                          ]
                                        ),
                                        _vm._l(
                                          _vm.mappingInfo.phoneNumber.list,
                                          function (item, key) {
                                            return _c(
                                              "a-select-option",
                                              {
                                                key: key,
                                                class: [_vm.lang],
                                                attrs: { value: item },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "optionCont" },
                                                  [
                                                    _vm._v(
                                                      " " + _vm._s(item) + " "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            : _vm._e(),
                          _c(
                            "div",
                            {
                              staticClass: "popbox beauty-scroll",
                              staticStyle: { "margin-top": "12px" },
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass: "main-tit",
                                  class: [_vm.lang],
                                  style: {
                                    "text-align":
                                      _vm.lang == "AR" ? "right" : "left",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("HowtoimporttheCSVfile")) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "ptit",
                                  class: [_vm.lang],
                                  style: {
                                    "text-align":
                                      _vm.lang == "AR" ? "right" : "left",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "num",
                                      class: {
                                        rtl: _vm.lang == "AR" ? true : false,
                                      },
                                    },
                                    [_vm._v("1")]
                                  ),
                                  _c("span", { class: [_vm.lang] }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("DropCSVfilehere")) + " "
                                    ),
                                  ]),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  style: {
                                    "text-align":
                                      _vm.lang == "AR" ? "right" : "left",
                                  },
                                },
                                [
                                  _c("img", {
                                    staticClass: "search",
                                    attrs: {
                                      src: require("@/assets/img/leads/5-1.png"),
                                      alt: "",
                                    },
                                  }),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "ptit",
                                  class: [_vm.lang],
                                  style: {
                                    "text-align":
                                      _vm.lang == "AR" ? "right" : "left",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "num",
                                      class: {
                                        rtl: _vm.lang == "AR" ? true : false,
                                      },
                                    },
                                    [_vm._v("2")]
                                  ),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("Maptheimportedfile"))
                                    ),
                                  ]),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  style: {
                                    "text-align":
                                      _vm.lang == "AR" ? "right" : "left",
                                  },
                                },
                                [
                                  _c("img", {
                                    staticClass: "search",
                                    attrs: {
                                      src: require("@/assets/img/leads/5-2.png"),
                                      alt: "",
                                    },
                                  }),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "ptit",
                                  class: [_vm.lang],
                                  style: {
                                    "text-align":
                                      _vm.lang == "AR" ? "right" : "left",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "num",
                                      class: {
                                        rtl: _vm.lang == "AR" ? true : false,
                                      },
                                    },
                                    [_vm._v("3")]
                                  ),
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.$t("Clicknextstep"))),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                        ]
                      : _vm.currentIndex == 6
                      ? [
                          _c(
                            "div",
                            { staticClass: "label-des", class: [_vm.lang] },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("EnterLinkedInGroupURL"))),
                              ]),
                            ]
                          ),
                          _c(
                            "a-form-item",
                            { class: [_vm.lang] },
                            [
                              _c("a-input", {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator",
                                    value: [
                                      "search_url6",
                                      {
                                        initialValue: _vm.search_url6,
                                        rules: [
                                          {
                                            required: true,
                                            validator: async function (
                                              rule,
                                              value,
                                              callback
                                            ) {
                                              if (!value || !value.trim("")) {
                                                callback(_vm.$t("selectUrl"))
                                                return
                                              }
                                              // 添加逻辑校验是否存在调接口
                                              let res =
                                                await _vm.isHaveSearchUrl(value)
                                              if (!res.reslut) {
                                                callback(res.msg)
                                                return
                                              }
                                              callback()
                                            },
                                          },
                                        ],
                                        trigger: "blur",
                                      },
                                    ],
                                    expression:
                                      "[\n                    'search_url6',\n                    {\n                      initialValue: search_url6,\n                      rules: [\n                        {\n                          required: true,\n                          validator: async function (rule, value, callback) {\n                            if (!value || !value.trim('')) {\n                              callback($t('selectUrl'));\n                              return;\n                            }\n                            // 添加逻辑校验是否存在调接口\n                            let res = await isHaveSearchUrl(value);\n                            if (!res.reslut) {\n                              callback(res.msg);\n                              return;\n                            }\n                            callback();\n                          },\n                        },\n                      ],\n                      trigger: 'blur',\n                    },\n                  ]",
                                  },
                                ],
                                staticClass: "input",
                                attrs: {
                                  size: "large",
                                  disabled: _vm.statusIsEdit,
                                  placeholder: _vm.$t(
                                    "PleaseenterLinkedInGroupURLhere"
                                  ),
                                },
                              }),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.showTipsInfo,
                                      expression: "showTipsInfo",
                                    },
                                  ],
                                  staticClass: "input-tip",
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "input-tip-icon" },
                                    [_vm._v("💡")]
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "input-tip-text" },
                                    [_vm._v(_vm._s(_vm.$t("PasteUrlTip")))]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "popbox popboxAni beauty-scroll" },
                            [
                              _c(
                                "p",
                                {
                                  staticClass: "main-tit",
                                  class: [_vm.lang],
                                  style: {
                                    "text-align":
                                      _vm.lang == "AR" ? "right" : "left",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("HowtofindLinkedInGroupURL")
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "ptit",
                                  class: [_vm.lang],
                                  style: {
                                    "text-align":
                                      _vm.lang == "AR" ? "right" : "left",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "num",
                                      class: {
                                        rtl: _vm.lang == "AR" ? true : false,
                                      },
                                    },
                                    [_vm._v("1")]
                                  ),
                                  _c("span", { class: [_vm.lang] }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("OpenLinkedInandfindthegroup")
                                      ) + " "
                                    ),
                                  ]),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  style: {
                                    "text-align":
                                      _vm.lang == "AR" ? "right" : "left",
                                  },
                                },
                                [
                                  _c("img", {
                                    staticClass: "search",
                                    attrs: {
                                      src: require("@/assets/img/leads/6-1.png"),
                                      alt: "",
                                    },
                                  }),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "ptit",
                                  class: [_vm.lang],
                                  style: {
                                    "text-align":
                                      _vm.lang == "AR" ? "right" : "left",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "num",
                                      class: {
                                        rtl: _vm.lang == "AR" ? true : false,
                                      },
                                    },
                                    [_vm._v("2")]
                                  ),
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.$t("ClickShowAll"))),
                                  ]),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  style: {
                                    "text-align":
                                      _vm.lang == "AR" ? "right" : "left",
                                  },
                                },
                                [
                                  _c("img", {
                                    staticStyle: {
                                      width: "280px",
                                      height: "auto",
                                      display: "inline",
                                    },
                                    attrs: {
                                      src: require("@/assets/img/leads/6-2.png"),
                                      alt: "",
                                    },
                                  }),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "ptit",
                                  class: [_vm.lang],
                                  style: {
                                    "text-align":
                                      _vm.lang == "AR" ? "right" : "left",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "num",
                                      class: {
                                        rtl: _vm.lang == "AR" ? true : false,
                                      },
                                    },
                                    [_vm._v("3")]
                                  ),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("Copythelinkandpasteithere2")
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  style: {
                                    "text-align":
                                      _vm.lang == "AR" ? "right" : "left",
                                  },
                                },
                                [
                                  _c("img", {
                                    staticClass: "search",
                                    attrs: {
                                      src: require("@/assets/img/leads/6-3.png"),
                                      alt: "",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
              ],
              1
            ),
          ]),
        ]),
        _c(
          "div",
          {
            staticClass: "wrap-btn",
            staticStyle: { "margin-top": "40px", "text-align": "center" },
          },
          [
            _c(
              "a-button",
              {
                class: [_vm.lang],
                staticStyle: { "margin-right": "20px" },
                attrs: { size: "large" },
                on: { click: _vm.backHandler },
              },
              [_vm._v(_vm._s(_vm.$t("back")))]
            ),
            !_vm.statusIsEdit
              ? _c(
                  "a-button",
                  {
                    staticClass: "save-draf-btn",
                    class: [_vm.lang],
                    staticStyle: { "margin-right": "20px" },
                    attrs: {
                      size: "large",
                      type: "primary",
                      ghost: "",
                      loading: _vm.draftLoading,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.clickHandler("saveDraft")
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("saveDraftBtn")) + " ")]
                )
              : _vm._e(),
            _c(
              "a-button",
              {
                class: [_vm.lang],
                attrs: { size: "large", type: "primary" },
                on: {
                  click: function ($event) {
                    return _vm.clickHandler("nextStep")
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("NextStep")))]
            ),
          ],
          1
        ),
      ]),
      _c(
        "a-modal",
        {
          attrs: { title: _vm.$t("quickVerification"), footer: null },
          model: {
            value: _vm.visible,
            callback: function ($$v) {
              _vm.visible = $$v
            },
            expression: "visible",
          },
        },
        [
          _c("p", [_vm._v(_vm._s(_vm.visibleInfo))]),
          _vm.visibleCode == 202
            ? _c("div", { staticClass: "phoneInfo" }, [
                _c(
                  "div",
                  { staticClass: "icon" },
                  [_c("a-icon", { attrs: { type: "mobile" } })],
                  1
                ),
                _c("div", { staticClass: "leftText" }, [
                  _c("div", { staticClass: "t1" }, [
                    _vm._v(_vm._s(_vm.$t("VerificationMethod"))),
                  ]),
                  _c("div", { staticClass: "t2" }, [
                    _vm._v(_vm._s(_vm.$t("LinkedInMobileApp"))),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm.visibleCode == 541
            ? _c(
                "div",
                [
                  _c(
                    "a-form",
                    {
                      ref: "formValid",
                      staticClass: "form",
                      attrs: { form: _vm.formValid },
                    },
                    [
                      _c(
                        "a-form-item",
                        { class: [_vm.lang] },
                        [
                          _c("a-input", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: [
                                  "validCode",
                                  {
                                    initialValue: _vm.validCode,
                                    trigger: "change",
                                    rules: [
                                      {
                                        required: true,
                                        message: _vm.$t("required"),
                                        validator: async function (
                                          rule,
                                          value,
                                          callback
                                        ) {
                                          if (!value || !value.trim("")) {
                                            callback(_vm.$t("required"))
                                            return
                                          }
                                          callback()
                                        },
                                      },
                                    ],
                                  },
                                ],
                                expression:
                                  "[\n              'validCode',\n              {\n                initialValue: validCode,\n                trigger: 'change',\n                rules: [\n                  {\n                    required: true,\n                    message: $t('required'),\n                    validator: async function (rule, value, callback) {\n                      if (!value || !value.trim('')) {\n                        callback($t('required'));\n                        return;\n                      }\n                      callback();\n                    },\n                  },\n                ],\n              },\n            ]",
                              },
                            ],
                            staticClass: "input",
                            attrs: {
                              size: "large",
                              placeholder: _vm.$t("EnterCode"),
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "footer-btn" },
            [
              _c(
                "a-button",
                { attrs: { size: "large" }, on: { click: _vm.cancelHandler } },
                [_vm._v(" " + _vm._s(_vm.$t("cancel")) + " ")]
              ),
              _c(
                "a-button",
                {
                  attrs: {
                    size: "large",
                    type: "primary",
                    loading: _vm.loadingCode,
                  },
                  on: { click: _vm.submitHandler },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.visibleCode == 541
                          ? _vm.$t("submit")
                          : _vm.$t("ApprovedApp")
                      ) +
                      " "
                  ),
                ]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }